import { FEATURE_STATUS_PENDING, FEATURE_STATUS_RERUNNING } from "config";
import {
  getProjectFeatureStatus,
  mapProjectFeatureStatusesToFeatureStatus,
  type ProjectFeatureStatusItem,
} from "utils";

export const SCRIPT_AI_HUB_FEATURES = [
  "script_breakdown",
  "character_breakdown",
  "coverage",
] as const;

export type ScriptAiHubFeature = (typeof SCRIPT_AI_HUB_FEATURES)[number];

export function isScriptAiHubFeatureRunning(
  featureStatuses: ProjectFeatureStatusItem[] | undefined,
  projectId: string | number,
  feature: ScriptAiHubFeature
): boolean {
  if (!featureStatuses?.length) return false;
  const mapped = mapProjectFeatureStatusesToFeatureStatus(featureStatuses, projectId);
  const status = getProjectFeatureStatus(mapped, feature)?.status;
  return status === FEATURE_STATUS_RERUNNING || status === FEATURE_STATUS_PENDING;
}

/** First in-flight hub pipeline (script → character → coverage) for overlay copy and visuals. */
export function getActiveScriptHubPipelineId(
  featureStatuses: ProjectFeatureStatusItem[] | undefined,
  projectId: string | number
): ScriptAiHubFeature | null {
  for (const feature of SCRIPT_AI_HUB_FEATURES) {
    if (isScriptAiHubFeatureRunning(featureStatuses, projectId, feature)) {
      return feature;
    }
  }
  return null;
}

export function isScriptHubFeatureStatusActive(
  featureStatuses: ProjectFeatureStatusItem[] | undefined,
  projectId: string | number
): boolean {
  if (!featureStatuses?.length) return false;
  return SCRIPT_AI_HUB_FEATURES.some((feature) =>
    isScriptAiHubFeatureRunning(featureStatuses, projectId, feature)
  );
}
